/* This file is autogenerated, see readme.md for instructions */
import DateTimeSvgIcon from '@bloomreach/banana-theme/icons/date-time.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const DateTimeIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <DateTimeSvgIcon />
    </Icon>
  );
});

DateTimeIcon.displayName = 'DateTimeIcon';

export default DateTimeIcon;
